import { Spinner } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

enum Phase {
  UNINITIALIZED,
  STARTED,
  FINISHED,
  ERROR,
}

const SessionTransferPage = observer((): React.JSX.Element => {
  const {
    sessionTransferStore,
    routeStore,
    uiStore: { showErrorNotice },
  } = useStores();
  const [phase, setPhase] = React.useState<Phase>(Phase.UNINITIALIZED);
  const [redirectUrl, setRedirectUrl] = React.useState<string>('');
  const formRef = React.useRef<HTMLFormElement | null>(null);
  const [ssoUrl, setSsoUrl] = React.useState<string>('');
  const [transferToken, setTransferToken] = React.useState<string>('');

  React.useEffect(() => {
    try {
      const startOrFinishTransfer = async () => {
        if (routeStore.decodedParams.goto) {
          const [token, url] = await sessionTransferStore.start(routeStore.decodedParams.goto);
          setSsoUrl(url);
          setTransferToken(token);
          setPhase(Phase.STARTED);
          return;
        }
        if (routeStore.decodedParams.transferToken) {
          const redirectUrl = await sessionTransferStore.end(routeStore.decodedParams.transferToken);
          setPhase(Phase.FINISHED);
          setRedirectUrl(redirectUrl);
          return;
        }
        setPhase(Phase.ERROR);
        showErrorNotice('error.sessionTransfer.noParams');
      };

      startOrFinishTransfer();
    } catch (_e) {
      setPhase(Phase.ERROR);
    }
  }, []);

  React.useEffect(() => {
    handlePhase();
  }, [formRef.current, phase]);

  const handlePhase = () => {
    switch (phase) {
      case Phase.STARTED:
        formRef.current?.submit();
        break;
      case Phase.FINISHED:
        redirectUrl && routeStore.route(redirectUrl);
        break;
      case Phase.UNINITIALIZED:
        break;
      default:
        showErrorNotice('error.sessionTransfer.noParams');
    }
  };

  if (phase === Phase.STARTED) {
    return (
      <>
        <Spinner />
        <form ref={formRef} action={`${ssoUrl}/transfer-session`}>
          <input type="hidden" name="transferToken" value={transferToken} />
        </form>
      </>
    );
  } else if (phase !== Phase.ERROR) {
    return <Spinner />;
  }

  return <></>;
});

export default SessionTransferPage;
